import Cookies from "js-cookie";

export default function () {
  var GMP = (function (GMP, $) {
    (GMP.Favourite = {
      init: function () {
        var $header = $(".question__header");
        var $id = $header.attr("id");
        var $favourite = $header.hasClass("favourite") ? true : false;
        var $headerId = "#" + $id;
        var $isFavouritePage = $("body").hasClass("template-favourites")
          ? true
          : false;
        if ($isFavouritePage) {
          var $el = $(this).closest(".question__favourite");
        }

        GMP.Favourite.bind($id, $favourite, $headerId, $isFavouritePage, $el);
      },

      bind: function ($id, $favourite, $headerId, $isFavouritePage, $el) {
        var $favouriteIcon = $($headerId + " .question__favourite-icon");

        $("body, .question__answer").bind("keyup", "Ctrl+f", function () {
          GMP.Favourite.addFavourite(
            $id,
            $favourite,
            $headerId,
            $isFavouritePage,
            $el,
            $favouriteIcon
          );
        });

        $favouriteIcon.on("click", function () {
          GMP.Favourite.addFavourite(
            $id,
            $favourite,
            $headerId,
            $isFavouritePage,
            $el,
            $favouriteIcon
          );
        });
      },

      addFavourite: function (
        $id,
        $favourite,
        $headerId,
        $isFavouritePage,
        $el,
        $favouriteIcon
      ) {
        const GMP_AJAX = window.GMP_AJAX;

        $.ajax({
          type: "post",
          url: GMP_AJAX.ajax_url,
          data: {
            action: "process_favourite",
            id: $id,
            favourite: $favourite,
            security: GMP_AJAX.ajax_nonce,
          },
          cache: false,
          async: true,
          headers: {
            "cache-control": "no-cache",
          },
          success: function () {
            if ($favourite === true) {
              $($headerId).removeClass("favourite");
              $favouriteIcon.removeClass("favourite");
            } else {
              $($headerId).addClass("favourite");
              $favouriteIcon.addClass("favourite");
            }
            $favouriteIcon
              .addClass("animated heartBeat fast")
              .on("animationend", function () {
                if ($isFavouritePage) {
                  $el.hide("slow", function () {
                    $el.remove();
                  });
                }
                $favouriteIcon.removeClass("animated heartBeat fast");
              });
          },
        });
      },
    }),
      (GMP.Questions = {
        init: function () {
          GMP.Questions.bind();
        },

        bind: function () {
          const GMP_AJAX = window.GMP_AJAX;
          var $answer = $(".question__answer");
          var $id = $answer.data("id");
          if ($answer.length === 0) {
            $answer = $(".question__answer-locked");
            $id = $answer.data("id");
            var locked = true;
          }
          var $prevLockedQ = $(".question__locked-prev");
          var $nextLockedQ = $(".question__locked-next");
          var $saveQ = $(".question__save");
          var $prevQ = $(".question__prev");
          var $nextQ = $(".question__next");
          var $resetQ = $(".question__reset");
          var $question = $(".question");
          var $page = $answer.data("page");
          var $taxonomy = $(".question").data("taxonomy");
          var $qNumbers = $(".nav__tertiary-number");
          var $readMore = $(".question__favourite-load-more-btn");
          var $lastQ = $("#is_last_question");
          var $lastQClose = $(".section-end__close");
          var $overlay = $(".overlay");
          var $print = $(".end-print-trigger");
          var $printPopup = $("#print__modal");
          var $sectionEndModal = $("#section-end__modal");
          var $delete = false;
          var $previousYearBtns = $(".question__related-year");
          var $relatedCopy = $(".question__related-copy");
          const _ = window.lodash;

          if ($previousYearBtns.length > 0) {
            const $initialTarget = $(".question__related-year.active");
            var $target = $initialTarget.attr("data-year");

            $previousYearBtns.on("click", function (event) {
              event.preventDefault();
              $(".question__related-year").removeClass("active");
              $(this).addClass("active");
              $target = $(this).attr("data-year");

              $(".question__related-answer-content").addClass("hidden");
              $("#" + $target).removeClass("hidden");
              $relatedCopy.attr("data-year", $target);
            });

            $(document).bind("keydown", "Shift+up", function () {
              GMP.Questions.copyPrevious($target);
            });

            $answer.bind("keydown", "Shift+up", function () {
              GMP.Questions.copyPrevious($target);
            });
          }

          const autoSave = _.debounce(function (e) {
            if (e.which === 13 || e.which === 16 || e.which === 37) {
              return;
            }
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy,
              true
            );
          }, 3000);

          if (
            $(".section__wrapper").length > 0 ||
            $(".tip__wrapper").length > 0 ||
            $(".intro__wrapper").length > 0
          ) {
            $(document).bind("keydown", "Shift+return", function () {
              bindNextAction();
            });
            $(document).bind("keydown", "Shift+left", function () {
              bindPrevAction();
            });
          } else {
            // Active answers
            $answer.bind("keydown", "Shift+return", (e) => {
              autoSave.cancel();
              bindNextAction();
              e.preventDefault();
            });
            $answer.bind("keydown", "Shift+left", () => {
              bindPrevAction();
            });
            $answer.bind("keydown", "Ctrl+s", () => {
              GMP.Questions.saveQuestion(
                $id,
                $saveQ,
                GMP_AJAX,
                $delete,
                $taxonomy
              );
            });

            $(document).bind("keydown", "Ctrl+s", function () {
              GMP.Questions.saveQuestion(
                $id,
                $saveQ,
                GMP_AJAX,
                $delete,
                $taxonomy
              );
            });

            // AutoSave
            if (!locked) {
              $answer.bind("keyup", autoSave);
            }
          }

          // Locked Answer navigation
          $prevLockedQ.on("click", () => {
            GMP.Questions.getQuestion(
              $id,
              $question,
              $page,
              $qNumbers,
              GMP_AJAX,
              "prev",
              $taxonomy,
              "locked"
            );
          });

          $nextLockedQ.on("click", () => {
            if ($lastQ.length) {
              var $currTermId = $lastQ.data("term");
              GMP.Questions.lastQuestion(
                $currTermId,
                GMP_AJAX,
                $overlay,
                $taxonomy
              );
              return;
            }

            GMP.Questions.getQuestion(
              $id,
              $question,
              $page,
              $qNumbers,
              GMP_AJAX,
              "next",
              $taxonomy,
              "locked"
            );
          });

          const bindNextAction = () => {
            autoSave.cancel();
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy
            );
            if ($lastQ.length) {
              var $currTermId = $lastQ.data("term");
              GMP.Questions.lastQuestion(
                $currTermId,
                GMP_AJAX,
                $overlay,
                $taxonomy
              );
              return;
            }

            GMP.Questions.getQuestion(
              $id,
              $question,
              $page,
              $qNumbers,
              GMP_AJAX,
              "next",
              $taxonomy
            );
          };

          const bindPrevAction = () => {
            autoSave.cancel();
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy
            );
            GMP.Questions.getQuestion(
              $id,
              $question,
              $page,
              $qNumbers,
              GMP_AJAX,
              "prev",
              $taxonomy
            );
          };

          $saveQ.on("click", function () {
            $saveQ.addClass("animated bounceOut faster animate-out");
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy
            );
          });

          $prevQ.on("click", function () {
            autoSave.cancel();
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy
            );
            GMP.Questions.getQuestion(
              $id,
              $question,
              $page,
              $qNumbers,
              GMP_AJAX,
              "prev",
              $taxonomy
            );
          });

          $nextQ.on("click", function () {
            autoSave.cancel();
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy
            );
            if ($lastQ.length) {
              var $currTermId = $lastQ.data("term");
              GMP.Questions.lastQuestion(
                $currTermId,
                GMP_AJAX,
                $overlay,
                $taxonomy
              );
            } else {
              GMP.Questions.getQuestion(
                $id,
                $question,
                $page,
                $qNumbers,
                GMP_AJAX,
                "next",
                $taxonomy
              );
            }
          });

          $(window).load(function () {
            GMP.Questions.markCurrent($qNumbers);
            GMP.Questions.setStyling();
          });

          $resetQ.on("click", function () {
            $delete = true;
            $resetQ.addClass("animated bounceOut faster animate-out");
            GMP.Questions.resetQuestion($id, $answer, $qNumbers, $resetQ);
            GMP.Questions.saveQuestion(
              $id,
              $saveQ,
              GMP_AJAX,
              $delete,
              $taxonomy
            );
          });

          $readMore.on("click", function () {
            $(this)
              .closest(".question__favourite-content")
              .toggleClass("expand");
          });

          $lastQClose.on("click", function () {
            $overlay.fadeOut(500);
            $lastQClose.parent().fadeOut(500);
          });

          $print.on("click", function () {
            $sectionEndModal.fadeOut();
            $printPopup.fadeIn(500).addClass("open");
          });

          $relatedCopy.on("click", function (e) {
            e.preventDefault();
            var $target = $(this).attr("data-year");
            GMP.Questions.copyPrevious($target);
          });
        },

        removeBinds: function () {
          $(document).unbind("keydown");

          $(".question__answer").unbind("keydown");
        },

        copyPrevious: function ($target) {
          var $answerInput = $(".question__answer");
          var existingText = $answerInput.html();
          if (existingText === '<p><br data-mce-bogus="1"></p>') {
            existingText = "";
          } else {
            existingText = existingText + "<br>";
          }
          var text = $("#" + $target).html();

          if (text.indexOf("You didn’t complete this question in") == -1) {
            $answerInput.html(existingText + text).focus();
          }
        },

        saveQuestion: function (
          $id,
          $saveQ,
          GMP_AJAX,
          $delete,
          $taxonomy,
          $autoSave = false
        ) {
          if ($autoSave) {
            $(".question__autosave").css("opacity", 1).addClass("saving");
          }
          var $answerContent;
          var $answer = $(".question__answer");
          var onlyImage = false;
          var $textChildren = $answer.children();
          if ($textChildren.length > 0) {
            for (let index = 0; index < $textChildren.length; index++) {
              if ($textChildren[index].innerHTML.includes("<img")) {
                onlyImage = true;
              }
            }
          }

          if ($answer.text() == "" && !onlyImage) {
            $answerContent = "";
          } else {
            $answerContent = $answer.html();
          }

          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "save_question",
              id: $id,
              answer: $answerContent,
              delete: $delete,
              taxonomy: $taxonomy,
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            success: function (response) {
              $saveQ
                .removeClass("bounceOut faster")
                .addClass("success bounceIn faster")
                .on("animationend", function () {
                  $saveQ.removeClass("bounceIn faster");
                });

              if (response) {
                try {
                  var data = JSON.parse(response);
                } catch (err) {
                  return;
                }

                $("#section-end__message").html(data.content);
                $(".section-end__buttons").hide();
                $("#section-end__modal").css({ padding: "100px 80px" });
                $(".overlay").fadeIn(500);
                $("#section-end__modal").fadeIn(1000);

                if (data.animation == "hearts") {
                  $("#hearts-canvas").show();
                  GMP.Hearts.render();
                } else if (data.animation == "confetti") {
                  $("#section-end-canvas").show();
                  GMP.Confetti.render();
                } else if (data.animation == "fireworks") {
                  $("#section-end-canvas").show();
                  GMP.Fireworks.render();
                } else if (data.animation == "school") {
                  $("#section-end-canvas").show();
                  GMP.Cheerleader.render();
                }

                setTimeout(function () {
                  $(".overlay").fadeOut();
                  $("#section-end__modal").fadeOut();
                  $("#section-end-canvas").hide();
                }, parseInt(GMP_AJAX.animation_duration));
              }

              $answer.focus();

              setTimeout(function () {
                $saveQ.removeClass("success");
                $(".question__autosave")
                  .css("opacity", 0)
                  .removeClass("saving");
              }, 500);
            },

            error: function (response) {
              console.log(response);
            },
          });
        },

        getQuestion: function (
          $id,
          $question,
          $page,
          $qNumbers,
          GMP_AJAX,
          $direction,
          $taxonomy,
          locked
        ) {
          if (!locked) {
            var $tinyMCE = window.tinyMCE;
            var $tinySettings = $tinyMCE.activeEditor.settings;
          }
          var $animateIn;
          var $animateOut;
          $(".tooltip").hide();

          if ($direction === "prev") {
            $question.removeClass("fadeInUp");
            $animateIn = "fadeInDown";
            $animateOut = "fadeOutDown";
          } else if ($direction === "next") {
            $animateIn = "fadeInUp";
            $animateOut = "fadeOutUp";
          }

          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "get_question",
              query_vars: GMP_AJAX.query_vars,
              page: $page,
              direction: $direction,
              taxonomy: $taxonomy,
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            beforeSend: function () {
              GMP.Questions.removeBinds();
              if (!locked) {
                $tinyMCE.remove(".question__answer");
              }
              $question.addClass("animated " + $animateOut + " faster");
            },
            success: function (response) {
              try {
                var data = JSON.parse(response);
              } catch (err) {
                return;
              }

              $qNumbers
                .filter(function () {
                  return $(this).data("id") === $id;
                })
                .addClass("complete")
                .removeClass("current");

              $question.html(data.template);
              $question.removeClass($animateOut);

              $question
                .addClass($animateIn + " faster")
                .on("animationend", function () {
                  if (!locked) {
                    $tinyMCE.init($tinySettings);
                  }
                });

              GMP.Questions.markCurrent($qNumbers);

              GMP.NavPosition.bind();

              const historyLink =
                $taxonomy === "areas_of_life"
                  ? `/2021-areas-of-life/${data.query_vars.areas_of_life}`
                  : `/${$taxonomy}/${data.query_vars[$taxonomy]}`;
              let new_url = `${window.location.origin}${historyLink}/page/${data.query_vars.paged}`;
              window.history.pushState("data", "", new_url);

              GMP.Questions.init();
              GMP.Favourite.init();
              GMP.Questions.setStyling();
              $(".question__answer").focus();
              $(document).foundation();
              // Setup hotkey for adding item
              $("body, .question__answer").bind("keyup", "Ctrl+a", function () {
                $(".action-list__add li.add").removeClass("hidden");
                $(".action-list__form").find("input").focus();
              });
              $("html, body").animate({ scrollTop: 0 });
            },
          });
        },

        setStyling: function () {
          var $footer = $(".question__footer");
          var $qNumberWidth = $(".question__number");
          $(".question__answer, .question__answer-locked").css({
            "margin-left": $qNumberWidth.outerWidth(true),
          });
          $footer.css({
            "margin-left": $qNumberWidth.outerWidth(true),
          });
        },

        markCurrent: function ($qNumbers) {
          var $newId = $(".question__answer").data("id");
          $qNumbers
            .filter(function () {
              return $(this).data("id") === $newId;
            })
            .addClass("current");
        },

        resetQuestion: function ($id, $answer, $qNumbers, $resetQ) {
          $answer.html("");
          $answer.focus();
          $qNumbers
            .filter(function () {
              return $(this).data("id") === $id;
            })
            .removeClass("complete");

          $resetQ
            .removeClass("bounceOut faster")
            .addClass("trashed bounceIn faster");

          setTimeout(function () {
            $resetQ.removeClass("trashed");
          }, 1000);
        },

        lastQuestion: function ($currTermId, GMP_AJAX, $overlay, $taxonomy) {
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "last_question_modal",
              termId: $currTermId,
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            success: function (response) {
              let info;
              try {
                info = JSON.parse(response);
              } catch (error) {
                // TODO do some error handling here
                return;
              }

              $("#section-end__message").html(info.message);
              $("#section-end__button").html(info.button_text);
              if (info.next_term == "last_term") {
                $("#section-end__button").attr("href", info.button_link);
                $(".section-end__close").show();
                GMP.Questions.init();
              } else {
                $("#section-end__button").attr(
                  "href",
                  "/" +
                    ($taxonomy === "areas_of_life"
                      ? "2021-areas-of-life"
                      : $taxonomy) +
                    "/" +
                    info.next_term
                );
              }

              $overlay.fadeIn(500);
              $("#section-end__modal").fadeIn(1000);

              if (info.animation == "hearts") {
                $("#hearts-canvas").show();
                GMP.Hearts.render();
              } else if (info.animation == "confetti") {
                $("#section-end-canvas").show();
                GMP.Confetti.render();
              } else if (info.animation == "fireworks") {
                $("#section-end-canvas").show();
                GMP.Fireworks.render();
              } else if (info.animation == "school") {
                $("#section-end-canvas").show();
                GMP.Cheerleader.render();
              }
            },
          });
        },
      }),
      (GMP.AccountDropDown = {
        init: function () {
          GMP.AccountDropDown.bind();
        },

        bind: function () {
          var $headerProfile = $(".header__profile");
          var $headerDropDown = $("#account__dropdown");
          var $accountPopup = $("#account__profile");
          var $overlay = $(".overlay");
          var $popupClose = $(".account__close");
          var $updateImageTrigger = $(".update-image-trigger");
          var $imagePopup = $("#account__profile-update-image");

          $headerProfile.on("click", function () {
            $("html, body").animate({ scrollTop: 0 });
            $headerDropDown.toggle();
          });

          $popupClose.on("click", function () {
            $overlay.fadeOut(500);
            $popupClose.parent().fadeOut(500);
          });

          $updateImageTrigger.on("click", function () {
            $accountPopup.fadeOut(200).removeClass("open");
            $imagePopup.fadeIn(500).addClass("open");
          });

          $(document).keyup(function (e) {
            if (e.keyCode === 27) {
              if ($accountPopup.hasClass("open")) {
                $overlay.fadeOut(500);
                $accountPopup.fadeOut(500).removeClass("open");
              } else if ($imagePopup.hasClass("open")) {
                $overlay.fadeOut(500);
                $imagePopup.fadeOut(500).removeClass("open");
              }
            }
          });

          $(document).on("click", function (e) {
            if ($(e.target).closest(".header__profile").length != 0)
              return false;
            $headerDropDown.fadeOut(500);
          });
        },
      }),
      (GMP.ActionList = {
        init: function () {
          GMP.ActionList.bind();
        },

        bind: function () {
          var $addItem = $(".action-list header i.gmp-plus");
          var $inputItem = $(".action-list__add li.add");
          var $form = $(".action-list__form");
          var $inputField = $form.find("input");
          var $expandIcon = $(".action-list header i.gmp-arrow-down");
          var $actionList = $(".action-list");
          var $closeIcon = $(".action-list i.gmp-arrow-up");
          var $listItem = ".action-list__list-item .action-list__icon";
          var $loading = $(".action-list__add li.loading");
          const GMP_AJAX = window.GMP_AJAX;
          var $deleteIcon = $(".action-list__delete");
          var $editIcon = $(".action-list__edit");
          var $editField = $(".action-list__text-edit-field");

          GMP.ActionList.addItem(
            $form,
            $inputField,
            $inputField,
            $loading,
            GMP_AJAX
          );
          GMP.ActionList.completeItem($listItem, GMP_AJAX);
          GMP.ActionList.showPriority();
          GMP.ActionList.setPriority(GMP_AJAX);
          GMP.ActionList.updateOrder(GMP_AJAX);

          // Add item
          $addItem.on("click", function () {
            $inputItem.removeClass("hidden");
            $inputField.focus();
          });

          // Delete item
          $deleteIcon.on("click", function () {
            var $item = $(this).parent();
            var $itemId = $item.attr("id");
            $(this)
              .addClass("rotate")
              .delay(150)
              .queue(function (next) {
                $(this).addClass("deleted");
                next();
              });
            GMP.ActionList.deleteItem($item, $itemId, GMP_AJAX);
          });

          $editIcon.on("click", function () {
            var $item = $(this).parent();
            $item.find(".action-list__text").fadeOut();
            setTimeout(() => {
              $item
                .find(".action-list__text-edit")
                .removeClass("hidden")
                .fadeIn();
              $item.find(".action-list__text-edit-field").focus();
            }, 400);
          });

          $editField.on("blur", function () {
            var $item = $(this).parents(".action-list__list-item");
            var $itemId = $item.attr("id");
            var $newValue = $item.find(".action-list__text-edit-field").val();
            GMP.ActionList.updateItem($item, $itemId, $newValue, GMP_AJAX);
          });

          $editField.on("keypress", function (event) {
            var keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode == "13") {
              var $item = $(this).parents(".action-list__list-item");
              var $itemId = $item.attr("id");
              var $newValue = $item.find(".action-list__text-edit-field").val();
              GMP.ActionList.updateItem($item, $itemId, $newValue, GMP_AJAX);
            }
          });

          // Setup hotkey for adding item
          $("body, .question__answer").bind("keyup", "Ctrl+a", function () {
            $inputItem.removeClass("hidden");
            $inputField.focus();
          });

          // Hide field on blur
          $inputField.on("blur", function () {
            if ($inputField.val() === "") {
              $inputItem.addClass("hidden");
            }
          });

          // Expand list for mobile etc
          $expandIcon.on("click", function (e) {
            e.preventDefault();
            $actionList.addClass("expanded");
            $closeIcon.addClass("animated fadeIn fast");
          });

          // Close list for mobile etc
          $closeIcon.on("click", function (e) {
            e.preventDefault();
            $actionList.removeClass("expanded");
            $expandIcon.addClass("animated fadeIn fast delay-1s");
          });

          if ($(".action-list__priority").length) {
            document.body.addEventListener("click", function (e) {
              if (e.target.classList.contains("action-list__priority")) return;
              removePrioritySelect();
            });
          }

          const removePrioritySelect = () => {
            if ($(".action-list__priority-select").hasClass("show")) {
              $(".action-list__priority-select").removeClass("show");
            }
          };
        },

        updateOrder: function (GMP_AJAX) {
          $(".action-list__list").sortable({
            handle: ".action-list__sort",
            placeholder: "highlight",
            start: function (event, ui) {
              var startPos = ui.item.index();
              ui.item.attr("data-start-pos", startPos);
            },
            update: function () {
              var $itemsOrder = $(this).sortable("toArray").toString();

              $.ajax({
                type: "post",
                url: GMP_AJAX.ajax_url,
                data: {
                  action: "update_action_item_order",
                  order: $itemsOrder,
                  security: GMP_AJAX.ajax_nonce,
                },
                cache: false,
                async: true,
                headers: {
                  "cache-control": "no-cache",
                },
                success: function (response) {
                  console.log(response);
                },
              });
            },
          });
        },

        showPriority: function () {
          var $priority = $(".action-list__priority");

          $priority.on("click", function (e) {
            e.preventDefault();
            let child = $(this).children(".action-list__priority-select");
            if (child.hasClass("show")) {
              child.removeClass("show");
              return;
            }
            if ($(".action-list__priority-select").hasClass("show")) {
              $(".action-list__priority-select").removeClass("show");
            }
            child.toggleClass("show");
          });
        },

        setPriority: function (GMP_AJAX) {
          var $setPriority = $(".set-priority");
          $setPriority.on("click", function (e) {
            e.preventDefault();
            var $parent = $(this).closest("li.action-list__list-item");
            var $id = $(this).attr("data-id");
            var $priorityLevel = $(this).attr("data-priority");

            $.ajax({
              type: "post",
              url: GMP_AJAX.ajax_url,
              data: {
                action: "update_action_item_priority",
                id: $id,
                priority: $priorityLevel,
                security: GMP_AJAX.ajax_nonce,
              },
              cache: false,
              async: true,
              headers: {
                "cache-control": "no-cache",
              },
              success: function (response) {
                console.log(response);
                $parent
                  .removeClass(function (index, className) {
                    return (className.match(/\bpriority-\S+/g) || []).join(" ");
                  })
                  .addClass("priority-" + $priorityLevel);
              },
            });
          });
        },

        addItem: function ($form, $inputField, $inputItem, $loading, GMP_AJAX) {
          $form.each(function () {
            var $container = $(".action-list__list");

            $inputField.keypress(function (e) {
              if (e.which == 10 || e.which == 13) {
                e.preventDefault();
                if ($inputField.val() == "") {
                  return;
                }
                $.ajax({
                  type: "post",
                  url: GMP_AJAX.ajax_url,
                  data: {
                    action: "add_action_item",
                    field: $inputField.val(),
                    security: GMP_AJAX.ajax_nonce,
                  },
                  beforeSend: function () {
                    $inputItem.addClass("hidden");
                    $loading.removeClass("hidden");
                  },
                  success: function (response) {
                    $inputItem.removeClass("hidden");
                    $inputField.val("").focus();
                    $loading.addClass("hidden");
                    $container.append(response);
                  },
                });
              }
            });
          });
        },

        updateItem: function ($item, $itemId, $newValue, GMP_AJAX) {
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "edit_action_item",
              id: $itemId,
              newValue: $newValue,
              security: GMP_AJAX.ajax_nonce,
            },
            beforeSend: function () {
              $item.find(".action-list__text-edit").addClass("hidden");
              $item.find(".action-list__loading").removeClass("hidden");
            },
            success: function () {
              $item.find(".action-list__loading").addClass("hidden");
              setTimeout(() => {
                $item.find(".action-list__text").text($newValue).fadeIn();
              }, 400);
            },
          });
        },

        completeItem: function ($listItem, GMP_AJAX) {
          $("body").on("click", $listItem, function () {
            var $item = $(this);
            var $id = $item.parent().attr("id");

            if ($item.parent().hasClass("complete")) {
              GMP.ActionList.unCompleteItem($id, $item, GMP_AJAX);
              return;
            }

            $.ajax({
              type: "post",
              url: GMP_AJAX.ajax_url,
              data: {
                action: "complete_action_item",
                id: $id,
                security: GMP_AJAX.ajax_nonce,
              },
              cache: false,
              async: true,
              headers: {
                "cache-control": "no-cache",
              },
              success: function (response) {
                console.log(response);
                $item.parent().addClass("complete");
                $item.html('<i class="gmp-check"></i>');
                $item
                  .parent()
                  .addClass("animated fadeOutUp fast")
                  .on("animationend", function () {
                    $item.parent().remove();
                  });
              },
            });
          });
        },

        unCompleteItem: function ($id, $item, GMP_AJAX) {
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "uncomplete_action_item",
              id: $id,
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            success: function () {
              $item.parent().removeClass("complete");
              $item.html('<i class="gmp-circle"></i>');
            },
          });
        },

        deleteItem: function ($item, $itemId, GMP_AJAX) {
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "delete_action_item",
              id: $itemId,
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            success: function () {
              $item
                .addClass("animated fadeOut fast")
                .on("animationend", function () {
                  $item.removeClass("animated fadeOut fast").remove();
                });
            },
          });
        },
      }),
      (GMP.Search = {
        init: function () {
          GMP.Search.bind();
        },

        bind: function () {
          var $search = $("form#gmp_search-form");
          var $searchIcon = $(".header__search i");
          var $searchInput = $(".header__search-input");
          var $input = $("input[name=gmp_search]");
          var $container = $(".content__main");
          const GMP_AJAX = window.GMP_AJAX;

          $searchIcon.on("click", function () {
            $searchInput.toggleClass("expanded");
          });

          $search.on("submit", function (e) {
            e.preventDefault();

            GMP.Search.searchSubmit($input, $container, GMP_AJAX);
          });
        },

        searchSubmit: function ($input, $container, GMP_AJAX) {
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "gmp_search",
              search: $input.val(),
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            beforeSend: function () {
              $input.val("");
            },
            success: function (response) {
              $container
                .addClass("animated fadeOut fast")
                .on("animationend", function () {
                  $container.removeClass("animated fadeOut");
                  $container.html(response).addClass("animated fadeIn fast");
                  GMP.Search.searchFilter();
                });
            },
          });
        },

        searchFilter: function () {
          console.log("hello");

          $("#yearSelection").on("change", function (e) {
            var $target = e.target.value;
            $(".search-year").addClass("hidden");
            $("#" + $target).removeClass("hidden");
          });
        },
      }),
      (GMP.Print = {
        init: function () {
          GMP.Print.bind();
        },

        bind: function () {
          const GMP_AJAX = window.GMP_AJAX;
          var $overlay = $(".overlay");
          var $popupClose = $(".print__modal__close");
          var $printInput = $(".print__modal__input");
          var $fileName = $("#gmp-filename");
          var $pdfTitle = $("#pdf-title").val();
          var $printButton = $("#print_plan");
          var $printFileBlock = $(".print__modal__file");
          var $saveButton = $("#save_settings");
          var $downloadButton = $("#print__modal__link");
          var userId = $("#download_plan").attr("data-user-id");

          $popupClose.on("click", function () {
            $overlay.fadeOut(500);
            $popupClose.parent().fadeOut(500);
          });

          $printInput.focus(function () {
            $(this).parent().addClass("active");
          });

          $printInput.blur(function () {
            $(this).parent().removeClass("active");
          });

          $saveButton.on("click", (e) => {
            var $pdfSettings = {
              qFontSize: $("#questionFontSize").val(),
              qColor: $("#print__color-picker").val(),
              fontFamily: $("#fontFamily").val(),
              aFontSize: $("#answerFontSize").val(),
              pdfTitleOld: $pdfTitle,
              pdfTitleNew: $printInput.val(),
              pdfIncludeTodo: $('input[name="include-todo"').val(),
            };
            GMP.Print.savePDF(GMP_AJAX, $pdfSettings, $fileName, $printButton);
            e.preventDefault();
          });

          $printButton.on("click", (e) => {
            $printButton.addClass("active loader");
            GMP.Print.printPDF(
              GMP_AJAX,
              $printButton,
              $printFileBlock,
              $downloadButton,
              userId
            );
            e.preventDefault();
          });

          $(
            "#questionFontSize, #fontFamily, #answerFontSize, .print__modal__input, #include-todo"
          ).on("change", function () {
            $("#print__modal__save").addClass("open");
            $printButton.addClass("disabled");
          });

          $(document).ready(function () {
            $(
              "#fontFamily, #questionFontSize, #answerFontSize, #yearSelection"
            ).select2({
              minimumResultsForSearch: -1,
              templateResult: function (data, container) {
                if (data.element) {
                  $(container).addClass(data.id);
                }
                return data.text;
              },
            });
          });
        },

        savePDF: function (GMP_AJAX, $pdfSettings, $fileName, $printButton) {
          if ($pdfSettings.pdfTitleNew != $pdfSettings.pdfTitleOld) {
            $fileName.addClass("animated fadeOut fast");
          }
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "save_pdf_settings",
              pdfTitle: $pdfSettings.pdfTitleNew,
              qFontSize: $pdfSettings.qFontSize,
              qColor: $pdfSettings.qColor,
              fontFamily: $pdfSettings.fontFamily,
              aFontSize: $pdfSettings.aFontSize,
              includeTodo: $pdfSettings.pdfIncludeTodo,
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            success: function () {
              if ($pdfSettings.pdfTitleNew != $pdfSettings.pdfTitleOld) {
                $fileName
                  .html($pdfSettings.pdfTitleNew)
                  .removeClass("fadeOut")
                  .addClass("fadeIn fast")
                  .on("animationend", function () {
                    $fileName.removeClass("fadeOut animated fast");
                  });
              }
              $("#print__modal__save").removeClass("open");
              $printButton.removeClass("disabled");
            },
          });
        },

        printPDF: function (
          GMP_AJAX,
          $printButton,
          $printFileBlock,
          $downloadButton,
          userId
        ) {
          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            data: {
              action: "gmp_create_pdf",
              security: GMP_AJAX.ajax_nonce,
            },
            cache: false,
            async: true,
            headers: {
              "cache-control": "no-cache",
            },
            success: function (response) {
              $printButton.removeClass("active loader").addClass("success");
              $downloadButton.attr("href", response);
              $("#print__modal__link").attr("href", response);
              setTimeout(function () {
                $printButton.removeClass("success").fadeOut();

                $("#download_plan")
                  .attr("href", response)
                  .fadeIn()
                  .removeClass("hidden");
              }, 1500);

              if ($printFileBlock.hasClass("hidden-animated")) {
                $printFileBlock.addClass("visible");
              }
              setTimeout(() => {
                $.ajax({
                  type: "post",
                  url: GMP_AJAX.ajax_url,
                  data: {
                    action: "delete_pdf",
                    security: GMP_AJAX.ajax_nonce,
                    userID: userId,
                  },
                  cache: false,
                  async: true,
                  headers: {
                    "cache-control": "no-cache",
                  },
                });
              }, 60000); // 1 minute
            },
            error: function (r) {
              console.log(r);
            },
          });
        },
      }),
      (GMP.FontColour = {
        init: function () {
          GMP.FontColour.bind();
        },

        bind: function () {
          $("#print__color-picker").spectrum({
            preferredFormat: "hex",
            showInput: true,
            showPalette: true,
            chooseText: "Yessir!",
            cancelText: "Nope",
            palette: [
              [
                "#000",
                "#444",
                "#666",
                "#999",
                "#ccc",
                "#eee",
                "#f3f3f3",
                "#fff",
              ],
              ["#f00", "#f90", "#ff0", "#0f0", "#0ff", "#00f", "#90f", "#f0f"],
              [
                "#f4cccc",
                "#fce5cd",
                "#fff2cc",
                "#d9ead3",
                "#d0e0e3",
                "#cfe2f3",
                "#d9d2e9",
                "#ead1dc",
              ],
              [
                "#ea9999",
                "#f9cb9c",
                "#ffe599",
                "#b6d7a8",
                "#a2c4c9",
                "#9fc5e8",
                "#b4a7d6",
                "#d5a6bd",
              ],
              [
                "#e06666",
                "#f6b26b",
                "#ffd966",
                "#93c47d",
                "#76a5af",
                "#6fa8dc",
                "#8e7cc3",
                "#c27ba0",
              ],
              [
                "#c00",
                "#e69138",
                "#f1c232",
                "#6aa84f",
                "#45818e",
                "#3d85c6",
                "#674ea7",
                "#a64d79",
              ],
              [
                "#900",
                "#b45f06",
                "#bf9000",
                "#38761d",
                "#134f5c",
                "#0b5394",
                "#351c75",
                "#741b47",
              ],
              [
                "#600",
                "#783f04",
                "#7f6000",
                "#274e13",
                "#0c343d",
                "#073763",
                "#20124d",
                "#4c1130",
              ],
            ],
            change: function () {
              $("#print__modal__save").addClass("open");
              $("#print_plan").addClass("disabled");
            },
          });
        },
      }),
      (GMP.Confetti = {
        render: function () {
          const GMP_AJAX = window.GMP_AJAX;
          window.renderConfetti();
          setTimeout(function () {
            $("#section-end-canvas").hide();
          }, parseInt(GMP_AJAX.animation_duration) + 500);
        },
      }),
      (GMP.Fireworks = {
        render: function () {
          const GMP_AJAX = window.GMP_AJAX;
          var canvas = document.getElementById("section-end-canvas");

          canvas.confetti =
            canvas.confetti || window.confetti.create(canvas, { resize: true });
          var duration = parseInt(GMP_AJAX.animation_duration);
          var animationEnd = Date.now() + duration;
          var defaults = {
            startVelocity: 30,
            spread: 360,
            ticks: 60,
            zIndex: 0,
          };

          function randomInRange(min, max) {
            return Math.random() * (max - min) + min;
          }

          var interval = setInterval(function () {
            var timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
              return clearInterval(interval);
            }

            var particleCount = 50 * (timeLeft / duration);
            // since particles fall down, start a bit higher than random
            canvas.confetti(
              Object.assign({}, defaults, {
                particleCount,
                origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
              })
            );
            canvas.confetti(
              Object.assign({}, defaults, {
                particleCount,
                origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
              })
            );
          }, 250);

          setTimeout(function () {
            $("#section-end-canvas").hide();
          }, parseInt(GMP_AJAX.animation_duration) + 500);
        },
      }),
      (GMP.Cheerleader = {
        render: function () {
          const GMP_AJAX = window.GMP_AJAX;
          var canvas = document.getElementById("section-end-canvas");
          canvas.confetti =
            canvas.confetti || window.confetti.create(canvas, { resize: true });

          var end = Date.now() + (parseInt(GMP_AJAX.animation_duration) - 500);

          var colors = ["#bb0000", "#ffffff"];

          (function frame() {
            canvas.confetti({
              particleCount: 2,
              angle: 60,
              spread: 55,
              origin: { x: 0 },
              colors: colors,
            });
            canvas.confetti({
              particleCount: 2,
              angle: 120,
              spread: 55,
              origin: { x: 1 },
              colors: colors,
            });

            if (Date.now() < end) {
              requestAnimationFrame(frame);
            }
          })();

          setTimeout(function () {
            $("#section-end-canvas").hide();
          }, parseInt(GMP_AJAX.animation_duration) + 1000);
        },
      }),
      (GMP.Hearts = {
        render: function () {
          const GMP_AJAX = window.GMP_AJAX;
          var canvas = $("#hearts-canvas");
          canvas.snowfall({
            image:
              "data:image/png;base64,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",
            minSize: 8,
            maxSize: 25,
            flakeCount: 60,
            maxSpeed: 6,
          });

          setTimeout(function () {
            $.when(canvas.fadeOut()).then(function () {
              canvas.snowfall("clear");
              canvas.hide();
            });
          }, parseInt(GMP_AJAX.animation_duration));
        },
      }),
      (GMP.NavPosition = {
        init: function () {
          GMP.NavPosition.bind();
        },
        bind: function () {
          const navLeft = $(".nav__arrow-left");
          const navRight = $(".nav__arrow-right");
          const navScroll = $("#scrollme");
          const navWidth = navScroll.outerWidth();

          if ($(".nav__tertiary-number").length) {
            setTimeout(function () {
              var offset = $(".nav__tertiary-number.current").offset();
              if (!offset) return;
              const scrollWidth = $(".nav__scroll").outerWidth();
              if (offset.left < scrollWidth - 30 && offset.left > 0) {
                return;
              }
              GMP.NavPosition.scroll(offset);
            }, 1500);
          }

          navLeft.on("click", function () {
            navScroll.animate(
              {
                scrollLeft: "-=" + navWidth + "px",
              },
              800
            );
          });

          navRight.on("click", function () {
            navScroll.animate(
              {
                scrollLeft: "+=" + navWidth + "px",
              },
              800
            );
          });
        },

        scroll: function (offset) {
          var pos = offset.left;
          if ($(window).width() > 640) {
            pos = offset.left - 175;
          }
          $(".nav__scroll").animate(
            {
              scrollLeft: pos,
            },
            1000
          );
        },
      }),
      (GMP.FilePond = {
        init: function () {
          GMP.FilePond.bind();
        },
        bind: function () {
          const GMP_AJAX = window.GMP_AJAX;
          const FilePond = window.FilePond;
          const FilePondPluginImagePreview = window.FilePondPluginImagePreview;
          const FilePondPluginFileValidateSize =
            window.FilePondPluginFileValidateSize;
          const FilePondPluginImageEdit = window.FilePondPluginImageEdit;
          const FilePondPluginImageTransform =
            window.FilePondPluginImageTransform;
          const FilePondPluginImageResize = window.FilePondPluginImageResize;
          const Doka = window.Doka;

          FilePond.registerPlugin(
            FilePondPluginImagePreview,
            FilePondPluginFileValidateSize,
            FilePondPluginImageEdit,
            FilePondPluginImageTransform,
            FilePondPluginImageResize
          );
          FilePond.create(document.querySelector("#cover_image"), {
            files: [
              {
                source: GMP_AJAX.coverImageUrl,
                options: {
                  type: "local",
                },
              },
            ],
            imageResizeTargetWidth: 2480,
            imageResizeTargetHeight: 3508,
            imageResizeUpscale: false,
            imagePreviewMaxHeight: 200,

            imageEditInstantEdit: true,

            imageEditEditor: Doka.create({
              cropAspectRatioOptions: [
                {
                  label: "Cover Size",
                  value: {
                    width: 2480,
                    height: 3508,
                  },
                },
              ],
            }),
            server: {
              load: (source, load) => {
                fetch(source)
                  .then((res) => res.blob())
                  .then(load);
              },
              process: (fieldName, file, metadata, load, error) => {
                const formData = new FormData();
                formData.append(fieldName, file, file.name);
                formData.append("action", "upload_cover_image");
                formData.append("coverImage", true);
                formData.append("security", GMP_AJAX.ajax_nonce);

                $.ajax({
                  url: GMP_AJAX.ajax_url,
                  method: "POST",
                  processData: false,
                  contentType: false,
                  data: formData,
                })
                  .success(function (response) {
                    console.log(response);
                    load(response.fileUrl);
                  })
                  .error(function (response) {
                    error(response);
                  });
              },
              fetch: null,
              revert: null,
            },
          });

          const pond = document.querySelector(".filepond--root");
          if (pond) {
            pond.addEventListener("FilePond:removefile", () => {
              if ($(".print__modal__file").hasClass("visible")) {
                $(".print__modal__file")
                  .removeClass("visible")
                  .addClass("hidden-animated");
              }
              $("#print_plan").fadeIn();
              $("#download_plan").fadeOut();

              $.ajax({
                url: GMP_AJAX.ajax_url,
                method: "POST",
                data: {
                  action: "remove_cover_image",
                  security: GMP_AJAX.ajax_nonce,
                },
              }).success(function (response) {
                console.log(response);
              });
            });
          }
        },
      }),
      (GMP.ProgressBar = {
        init: function () {
          GMP.ProgressBar.bind();
        },
        bind: function () {
          const ProgressBar = window.ProgressBar;

          if ($("#total-progress").length < 1) return;

          GMP.ProgressBar.totalProgress(ProgressBar);
          GMP.ProgressBar.healthProgress(ProgressBar);
          GMP.ProgressBar.wealthProgress(ProgressBar);
          GMP.ProgressBar.wisdomProgress(ProgressBar);
          GMP.ProgressBar.businessProgress(ProgressBar);
          GMP.ProgressBar.relationshipProgress(ProgressBar);
          GMP.ProgressBar.socialProgress(ProgressBar);
          GMP.ProgressBar.spiritualityProgress(ProgressBar);
          GMP.ProgressBar.lifeProgress(ProgressBar);
        },

        totalProgress: function (ProgressBar) {
          let progress = $("#total-complete").val();
          let total = new ProgressBar.Circle("#total-progress", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 10,
            easing: "easeInOut",
            text: {
              value: "0%",
              style: {
                // Text color.
                // Default: same as stroke color (options.color)
                color: "#000",
                position: "absolute",
                left: "50%",
                top: "43%",
                padding: 0,
                margin: 0,
                // You can specify styles which will be browser prefixed
                transform: {
                  prefix: true,
                  value: "translate(-50%, -50%)",
                },
              },
            },
            step: function (state, bar) {
              bar.setText(Math.round(bar.value() * 100) + "%");
            },
          });

          total.animate(progress);
          total.setText(progress + "%");
          window.addEventListener("load", () => {
            const totalLabel = document.querySelector(".total-label");
            totalLabel.classList.add("show");
          });
        },

        healthProgress: function (ProgressBar) {
          let progress = $("#health-percentage").val();
          let health = new ProgressBar.Circle("#health", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#health-complete").html(Math.round(bar.value() * 100));
            },
          });
          health.animate(progress);
        },
        wealthProgress: function (ProgressBar) {
          let progress = $("#wealth-percentage").val();
          let wealth = new ProgressBar.Circle("#wealth", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#wealth-complete").html(Math.round(bar.value() * 100));
            },
          });
          wealth.animate(progress);
        },
        wisdomProgress: function (ProgressBar) {
          let progress = $("#wisdom-percentage").val();
          let wisdom = new ProgressBar.Circle("#wisdom", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#wisdom-complete").html(Math.round(bar.value() * 100));
            },
          });
          wisdom.animate(progress);
        },
        businessProgress: function (ProgressBar) {
          let progress = $("#business-percentage").val();
          let business = new ProgressBar.Circle("#business", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#business-complete").html(Math.round(bar.value() * 100));
            },
          });
          business.animate(progress);
        },
        relationshipProgress: function (ProgressBar) {
          let progress = $("#relationship-percentage").val();
          let relationship = new ProgressBar.Circle("#relationship", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#relationship-complete").html(Math.round(bar.value() * 100));
            },
          });
          relationship.animate(progress);
        },
        socialProgress: function (ProgressBar) {
          let progress = $("#social-percentage").val();
          let social = new ProgressBar.Circle("#social", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#social-complete").html(Math.round(bar.value() * 100));
            },
          });
          social.animate(progress);
        },
        spiritualityProgress: function (ProgressBar) {
          let progress = $("#spirituality-percentage").val();
          let spirituality = new ProgressBar.Circle("#spirituality", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#spirituality-complete").html(Math.round(bar.value() * 100));
            },
          });
          spirituality.animate(progress);
        },
        lifeProgress: function (ProgressBar) {
          let progress = $("#life-percentage").val();
          let life = new ProgressBar.Circle("#life", {
            color: "#00dffc",
            fill: "rgba(0, 223, 252, 0.1)",
            duration: 2000,
            strokeWidth: 6,
            easing: "easeInOut",
            step: function (state, bar) {
              $("#life-complete").html(Math.round(bar.value() * 100));
            },
          });
          life.animate(progress);
        },
      }),
      (GMP.DaysLeft = {
        init: function () {
          GMP.DaysLeft.bind();
        },
        bind: function () {
          const ProgressBar = window.ProgressBar;

          if ($("#daysLeft").length < 1) return;

          GMP.DaysLeft.daysLeftAnimation(ProgressBar);
        },
        daysLeftAnimation: function (ProgressBar) {
          const $container = $("#daysLeft");

          let progress = $container.attr("data-value");
          let daysLeft = new ProgressBar.Line("#daysLeft", {
            color: "#00dffc",
            duration: 2000,
            strokeWidth: 1,
            easing: "easeInOut",
          });
          daysLeft.animate(progress);
        },
      }),
      (GMP.YearlyNav = {
        init: () => {
          GMP.YearlyNav.bind();
        },
        bind: () => {
          const yearLinks = document.querySelectorAll(".nav__list-year-link");
          GMP.YearlyNav.setCookies(yearLinks);

          const iconLink = document.querySelector(".nav__years a");

          iconLink.addEventListener("click", (e) => {
            e.preventDefault();
            GMP.YearlyNav.showYears();
          });
        },
        setCookies: (yearLinks) => {
          if (!yearLinks) return;
          for (let index = 0; index < yearLinks.length; index++) {
            yearLinks[index].addEventListener("click", (e) => {
              if (!e.target.dataset.locked) {
                Cookies.set("selectedYear", e.target.dataset.year);
              }
            });
          }
        },
        showYears: () => {
          const collapse = document.getElementById("yearsCollapse");
          if (!collapse) return;
          if (collapse.classList.contains("show")) {
            collapse.classList.remove("show");
          } else {
            collapse.classList.add("show");
          }
        },
      }),
      (GMP.ProfilePicUpload = {
        init: () => {
          GMP.ProfilePicUpload.bind();
        },
        bind: () => {
          const GMP_AJAX = window.GMP_AJAX;
          const fileUpload = document.getElementById("profileFileUpload");
          if (!fileUpload) return;
          fileUpload.addEventListener("change", (e) => {
            const formData = new FormData();
            const profileImage = e.target.files;
            formData.append("profileImage", profileImage[0]);
            formData.append("action", "upload_profile_pic");
            formData.append("security", GMP_AJAX.ajax_nonce);

            $.ajax({
              xhr: function () {
                var xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener(
                  "progress",
                  function (evt) {
                    if (evt.lengthComputable) {
                      $(".account__progress").fadeIn();
                      var percentComplete = (evt.loaded / evt.total) * 100;
                      $(".progress-bar").css("width", percentComplete + "%");
                    }
                  },
                  false
                );
                return xhr;
              },
              type: "post",
              url: GMP_AJAX.ajax_url,
              data: formData,
              processData: false,
              contentType: false,
              cache: false,
              async: true,
              headers: {
                "cache-control": "no-cache",
              },
              beforeSend: function () {
                $(".progress-bar").fadeIn();
                $(".progress-bar").width("0%");
              },
              error: function () {
                $("#uploadStatus").html(
                  '<p style="color:#EA4335;">File upload failed, please try again.</p>'
                );
              },
              success: function (res) {
                try {
                  const data = JSON.parse(res);
                  $(".account__profile-file").css("opacity", "0");
                  $(
                    ".account__profile-file, .account__profile-image, .header__profile-avatar"
                  ).css("background-image", 'url("' + data.imageUrl + '")');
                  $(".account__profile-file").css("opacity", "1");
                  $(".account__profile-button").fadeOut();
                  $(".account__profile-success").fadeIn();
                } catch (error) {
                  console.log(error);
                }
              },
            });
          });
        },
      }),
      $(function () {
        GMP.Favourite.init();
        GMP.Questions.init();
        GMP.AccountDropDown.init();
        GMP.ActionList.init();
        GMP.Search.init();
        GMP.Print.init();
        GMP.FontColour.init();
        GMP.NavPosition.init();
        GMP.FilePond.init();
        GMP.ProgressBar.init();
        GMP.YearlyNav.init();
        GMP.DaysLeft.init();
        GMP.ProfilePicUpload.init();
      });

    return GMP;
  })(GMP || {}, jQuery);
}



// WEBPACK FOOTER //
// ./scripts/components/SetupGMP.js